(() => {
	angular.module('main').controller('LeadViewController', LeadViewController);

	LeadViewController.$inject = [
		'$scope',
		'$rootScope',
		'$routeParams',
		'$location',
		'$http',
		'$filter',
		'$timeout',
		'timeService',
		'messageService',
		'templateRequestsService',
		'validationService',
		'workflowService',
		'fileUploadService',
		'imageConverter',
		'timeConverter',
		'emailService',
		'utilsService',
		'userService',
		'leadDataService',
		'contractsDataService',
		'notesDataService',
		'newJobsDataService',
		'clientsDataService',
		'clientService',
		'jobTypesDataService',
		'workflowDataService',
		'fileDownloadDataService',
		'stringModifierService',
		'settingsService',
		'fileUploadDataService',
		'mailsDataService',
		'questionnairesDataService',
		'contractService'
	];

	function LeadViewController(
		$scope,
		$rootScope,
		$routeParams,
		$location,
		$http,
		$filter,
		$timeout,
		timeService,
		messageService,
		templateRequestsService,
		validationService,
		workflowService,
		fileUploadService,
		imageConverter,
		timeConverter,
		emailService,
		utilsService,
		userService,
		leadDataService,
		contractsDataService,
		notesDataService,
		newJobsDataService,
		clientsDataService,
		clientService,
		jobTypesDataService,
		workflowDataService,
		fileDownloadDataService,
		stringModifierService,
		settingsService,
		fileUploadDataService,
		mailsDataService,
		questionnairesDataService,
		contractService
	) {
		// Requests
		const leadViewRequests = {
			sendNewContractEmail(data, successCallback, errorCallback) {
				if (id !== null) {
					const maxSize = 10; // 10Mb

					if (
						$scope.attachmentsDataContract &&
						$scope.attachmentsDataContract.filesSize > maxSize
					) {
						messageService.showToaster('w_0', 'attachments');
						$scope.initSendContractSpinningWheel = false;
						return false;
					}

					const formData = new FormData();

					angular.forEach(data, (value, key) => {
						formData.append(key, value);
					});

					const filesFromJob = $scope.attachmentsDataContract.attachments.filter(
						file => file.id
					);
					const filesFromComputer = $scope.attachmentsDataContract.attachments.filter(
						file => !file.id
					);

					angular.forEach(filesFromComputer, (value, key) => {
						formData.append(`attachments[${key}]`, value);
					});

					angular.forEach(filesFromJob, (value, key) => {
						formData.append(`storedAttachments[${key}]`, value.id);
					});

					const url = '/protected/rest/job/contract/save/';
					contractsDataService
						.sendContractRequest(url, formData)
						.subscribe(result => {
							successCallback(result);
							Intercom('trackEvent', 'sent contract');
						}, errorCallback);
				}
			},

			sendNewQuestionnaireEmail(data, successCallback, errorCallback) {
				if (id !== null) {
					const maxSize = 10; // 10Mb

					if (
						$scope.attachmentsDataQueston &&
						$scope.attachmentsDataQueston.filesSize > maxSize
					) {
						messageService.showToaster('w_0', 'attachments');
						return false;
					}

					const formData = new FormData();

					angular.forEach(data, (value, key) => {
						formData.append(key, value);
					});

					const filesFromJob = $scope.attachmentsDataQueston.attachments.filter(
						file => file.id
					);
					const filesFromComputer = $scope.attachmentsDataQueston.attachments.filter(
						file => !file.id
					);

					angular.forEach(filesFromComputer, (value, key) => {
						formData.append(`attachments[${key}]`, value);
					});

					angular.forEach(filesFromJob, (value, key) => {
						formData.append(`storedAttachments[${key}]`, value.id);
					});

					const url = '/protected/rest/job/questionnaire/save';
					questionnairesDataService
						.sendQuestionnaireRequest(url, formData)
						.subscribe(result => {
							successCallback(result);
							Intercom('trackEvent', 'sent questionnaire');
						}, errorCallback);
				}
			},

			getLead() {
				const newTaskId = $routeParams.task;
				return leadDataService
					.getLeadInfo(id, newTaskId)
					.map(data => removeLeadMails(data))
					.subscribe(
						data => successGetLeads(data),
						error => errorGetLeads(error)
					);
			}
		};

		function errorGetLeads(error) {
			const { errorCode, data } = error.error;
			if (errorCode === 102 || errorCode === 104) {
				$location.path('/leads');
				messageService.showToaster('e_7', 'lead');
			}
			if (errorCode === 701) {
				$location.path(`/${data.redirectTo}s/view/${data.redirectId}`);
			}
		}

		function successGetLeads(data) {
			$scope.archived = data.archived;
			const job = data.job;
			const lead = data;
			$scope.lead = JSON.parse(JSON.stringify(lead));
			$scope.job = JSON.parse(JSON.stringify(job));
			$scope.primaryContact = JSON.parse(JSON.stringify(job.primaryContact));
			$scope.secondaryContact = JSON.parse(
				JSON.stringify(job.secondaryContact)
			);
			$scope.leadId = data.id;
			$rootScope.jobId = $scope.job.id;
			prepareJob(job);
			prepareTasks();
			setContacts();
			calculateInvoices();
			setAttachments(data.job.attachments);
			$scope.getMails(false);
		}

		function removeParameters() {
			const {
				calendarView,
				calendarDate,
				page,
				search
			} = $location.search();
			if (
				calendarView ||
				calendarDate ||
				page
			) {
				$location.search({}).replace();
			}
		}

		$scope.$on('$viewContentLoaded', () => {
			removeParameters();

			$rootScope.jobViewLoaded = true;
			$scope.isSaveNotesSpinnningWheelActive = false;
			$scope.files = [];
			$scope.showAddNewTaskModalSpinningWheel = false;
			$scope.createNewInvoiceSpinningWheel = false;
			$scope.createNewQuoteSpinningWheel = false;
			$scope.initSendContractSpinningWheel = false;
			$scope.initSendQuestionnaireSpinningWheel = false;
			$scope.showSendEmailModalSpinningWheel = false;
			$scope.newTaskCreate = [];
			$scope.isCreateClientModalSpinnningWheelActive = false;
			$scope.isEditContractModalSpinnningWheelActive = false;
			$scope.loadFileSpinningWheelActive = false;
			$scope.isGetMailsSpinningWheelActive = false;

			$rootScope.dnd = { canMove: true };
			const attachmentsObj = { attachments: [], filesSize: 0 };
			$scope.attachmentsDataContract = angular.copy(attachmentsObj);
			$scope.tokenAttachmentsData = angular.copy(attachmentsObj);
			window.scrollTo(0, 0);
			$scope.now = new Date();
			$scope.now.setHours(12, 0, 0, 0);
			$scope.workflowNames = [];
			$scope.button_disable = true;
			$scope.userCurrencySymbol = userService.userCurrencySymbol;
			leadViewRequests.getLead();
			$scope.templates = {};
			$scope.unsubscribe = new Rx.Subject();
			$scope.primaryContact = null;
			$scope.secondaryContact = null;
			$scope.tickTask = false;
			$scope.tickTaskType = '';
			$scope.fundyIntegration = false;
			$scope.integrationInvoiceLoadXml = false;
			$scope.fundyAvailable = false;

			// ProSelect
			$scope.proSelectIntegration = false;
			$scope.proSelectAvailable = false;

			$scope.emailDataToSaveQuestion = {};
			$scope.emailDataToSaveContract = {};

			subscribeToCustomizeLabelsChange();

			settingsService.timeFormatSettings.subscribe(data => {
				if (data.fundyAvailable) {
					$scope.fundyAvailable = true;
					if (data.fundyIntegration === 'ENABLED') {
						$scope.fundyIntegration = true;
					}
				}

				if (data.proSelectAvailable) {
					$scope.proSelectAvailable = true;
					if (data.proSelectIntegration === 'ENABLED') {
						$scope.proSelectIntegration = true;
					}
				}

				$scope.leadSourcesAvailable = data.leadSourcesAvailable;
			});

			Rx.Observable.zip(
				templateRequestsService.getTemplates('contract_preview'),
				templateRequestsService.getTemplates('questionnaire_preview'),
				templateRequestsService.getTemplates('general_preview')
			).subscribe(
				([contracts, questionnaires, general]) => {
					setContractsPreview(contracts);
					setQuestionnairesPreview(questionnaires);
					setGeneralEmailsPreview(general);
				},
				error => showGeneralErrorMessage(error)
			);
		});

		$scope.$on('$destroy', () => {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		function subscribeToCustomizeLabelsChange() {
			settingsService.customizeLabelsObservable
				.takeUntil($scope.unsubscribe)
				.subscribe(customizeLabels => {
					$scope.mainShootLabelName = customizeLabels.mainShootLabel;
					$scope.extraShootLabelName = customizeLabels.extraShootLabel;
					$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
				});
		}

		const defaultWorkflow = {
			id: '',
			name: 'Default'
		};
		const id = $routeParams.leadId;

		$scope.saveFilesOnService = (item, leadId) => {
			$scope.loadFileSpinningWheelActive = true;

			if ($scope.loadFileSpinningWheelActive === true) {
				$('.btn-add-round').css('pointer-events', 'none');
			}

			const maxMb = 20; // 20 Mb
			const maxSize = maxMb * 1000 * 1024;

			const totalFilesSize = getTotalSize($scope.files);

			if (totalFilesSize + item.size > maxSize) {
				messageService.showToaster('w_1', 'attachments');
				$scope.loadFileSpinningWheelActive = false;
				return;
			}

			fileUploadService.saveFileOnServer(
				item,
				leadId,
				response => {
					response.convertedType = imageConverter.getFileClass(response.name);
					$scope.files.push(response);
					fileUploadService.setFiles(response);
					$scope.$broadcast('addedFileEvent');
					enableFileAddButton();
				},
				response => {
					const { errorMessage, errorTitle } = response;
					messageService.showErrorFromBackend(errorTitle, errorMessage);
					enableFileAddButton();
				}
			);
		};

		function enableFileAddButton() {
			$scope.loadFileSpinningWheelActive = false;
			if ($scope.loadFileSpinningWheelActive === false) {
				$('.btn-add-round').css('pointer-events', 'auto');
			}
		}

		function getTotalSize(files) {
			return files.reduce((prev, next) => prev + next.bytesSize, 0);
		}

		// $scope.saveAttachment = function(fileId, jobId) {
		// 	fileDownloadDataService.saveFile(fileId, jobId);
		// };

		$scope.deleteFile = file => {
			if ($scope.archived) {
				messageService.showToaster('e_6', 'lead');
			} else {
				$scope.file = file;
				$('#deleteAttachmentModal').modal('show');
			}
		};

		$scope.$on('removedFileEvent', event => {
			$scope.$broadcast('removedData');
		});

		// initial setup
		$scope.dateFilterJobMail = "dd MMMM yyyy 'at' HH:mm";

		// $scope.mailData2Save = {};
		$scope.contractData2Send = {};
		$scope.lead2Edit = {};
		$scope.clientEmails = [];

		let clientsEmailTimer;

		// attachments
		clearQuestAttachments();
		clearContractAttachments();

		// templates for workflow tasks
		function setContractsPreview(data) {
			$scope.templates.contractEmailTemplates = angular.copy(
				data.emailTemplates
			);
			$scope.templates.contracts = angular.copy(data.contractTemplates);
		}

		function setQuestionnairesPreview(data) {
			$scope.templates.questionnaireEmailTemplates = angular.copy(
				data.emailTemplates
			);
			$scope.templates.questionnaires = angular.copy(
				data.questionnaireTemplates
			);
		}

		function setGeneralEmailsPreview(data) {
			$scope.templates.generalEmailTemplates = angular.copy(data);
		}

		$scope.getMails = function(syncReply) {
			if (syncReply) {
				$rootScope.isMailResyncInProcess = true;
			}
			const subscription = mailsDataService
				.getJobMails($scope.jobId, syncReply)
				.subscribe(
					data => successGetMails(data.data, syncReply, subscription),
					error => errorGetMails(error, syncReply, subscription)
				);
		};

		function successGetMails(data, syncReply, subscription) {
			const { lastSyncResult, mails } = data;
			$scope.job.mails = mails;

			// check if google gmail service synchronized
			if (lastSyncResult && lastSyncResult != null) {
				// Show time for synchronized block
				$scope.isGoogleMailSynchronized = true;
				$scope.googleMailLastSyncDate = lastSyncResult.replySynchronizedAt;

				if (syncReply) {
					showCorrectMessage(lastSyncResult);
				}
			}

			if (syncReply) {
				$rootScope.isMailResyncInProcess = false;
			}

			subscription.unsubscribe();
		}

		function showCorrectMessage(lastSyncResult) {
			const status = lastSyncResult.status.toLowerCase();
			const messageType = messageService.getCorrectMessageType(status);

			if (status === 'ok') {
				messageService.showToaster('s_0', 'email');
			} else {
				messageService.showMessageFromBackend(
					messageType,
					lastSyncResult.messageDetails.title,
					lastSyncResult.messageDetails.message
				);
			}
		}

		function errorGetMails(error, syncReply, subscription) {
			if (syncReply) {
				$rootScope.isMailResyncInProcess = false;
			}
			messageService.showDefaultErrorMessage(error);
			subscription.unsubscribe();
		}

		// ATTENTION: Temporary hotfix, to resolve SN-2444.
		function removeLeadMails(data) {
			data.job.mails = [];
			return data;
		}

		$scope.unArchivedLead = leadId => {
			leadDataService.unarchiveLead(leadId).subscribe(
				() => {
					messageService.showToaster('s_6', 'lead');
					leadViewRequests.getLead();
				},
				error => {
					messageService.showDefaultErrorMessage(error);
				}
			);
		};
		$scope.archivedLead = leadId => {
			leadDataService.archiveLead(leadId).subscribe(
				() => {
					messageService.showToaster('s_5', 'lead');
					leadViewRequests.getLead();
				},
				error => {
					const { errorMessage } = error.error;
					if (errorMessage.includes('Lead contains invoices.')) {
						messageService.showToaster('e_4', 'lead');
					} else {
						messageService.showDefaultErrorMessage(error);
					}
				}
			);
		};

		$scope.$watch('primaryContact', newValue => {
			if (newValue) {
				$rootScope.primaryContact = $scope.primaryContact;
			}
		});

		// Contract methods
		$scope.initSendContract = () => {
			const addNewModal = $('#addNewModal');
			let DELAY = 500;

			if (addNewModal.hasClass('in')) {
				$('#addNewModal').modal('hide');
			} else {
				DELAY = 0;
			}

			templateRequestsService.getTemplates('contract_preview').subscribe(
				data => {
					successInitSendContract(data);
					$timeout(() => {
						$('#sendNewContractModal')
							.modal('show')
							.on('shown.bs.modal', () => {
								const input = $('#sendNewContractModal').find('input');

								validationService.isModalClosePrevented(input);
							});
					}, DELAY);
				},
				error => messageService.showDefaultErrorMessage(error)
			);
		};

		function successInitSendContract(data) {
			$scope.initSendContractSpinningWheel = true;
			$scope.contractSendSource = data;
			$scope.contracts = $scope.contractSendSource.contractTemplates;
			$scope.contractEmailTemplates = $scope.contractSendSource.emailTemplates;
			if ($scope.contractEmailTemplates) {
				const template =
					$scope.contractEmailTemplates.find(
						item => item.emailTemplateType === 'CONTRACT_EMAIL_TEMPLATE'
					) || {};

				$scope.chosenContractEmail = template;
				$scope.setContractEmailTemplate(template.id);
			}

			delete $scope.sendMessageContract;
			$scope.sendMessageContract = {};
			$scope.sendMessageContract.emailTo = $rootScope.primaryContact.email
				? [$rootScope.primaryContact.email]
				: [];
			if ($scope.secondaryContact) {
				$scope.sendMessageContract.emailTo.push($scope.secondaryContact.email);
			}
			$scope.sendMessageContract.emailCc = [];
			$scope.initSendContractSpinningWheel = false;
		}

		$scope.showSendContract = function(jobId, jobContractId, task) {
			$routeParams.contractId = jobContractId;
			$routeParams.jobId = jobId;

			delete $scope.sendMessage;
			$scope.sendMessage = {};
			$scope.sendMessage.emailTo = $rootScope.primaryContact.email
				? [$rootScope.primaryContact.email]
				: [];
			if ($scope.secondaryContact) {
				$scope.sendMessage.emailTo.push($scope.secondaryContact.email);
			}
			$scope.sendMessage.emailCc = [];
			$scope.sendMessage.isDisable = false;
			if (task !== undefined) {
				$scope.sendMessage.task = JSON.parse(JSON.stringify(task));
				$scope.sendMessage.jobId = jobId;
				$scope.sendMessage.sortedTasksArr = $scope.sortedTasksArr;
				$scope.sendMessage.isDisable = true;
			}

			templateRequestsService
				.getTemplates('contract_preview')
				.subscribe(data => successShowSendContract(data));

			if (jobContractId) {
				contractsDataService.getContract(jobId, jobContractId).subscribe(
					result => {
						$scope.contract = result.contract;
						$scope.$evalAsync();
					},
					err => messageService.showDefaultErrorMessage(err)
				);
			}
		};

		function successShowSendContract(data) {
			$scope.contractSendSource = data;
			$scope.contractEmailTemplates = $scope.contractSendSource.emailTemplates;
			if (
				$scope.contractEmailTemplates &&
				$scope.contractEmailTemplates.length > 0
			) {
				const template =
					$scope.contractEmailTemplates.find(
						item => item.emailTemplateType === 'CONTRACT_EMAIL_TEMPLATE'
					) || {};
				$scope.chosenContractEmail = template;
				$scope.setContractEmailTemplate(template.id);
			}
			$('#sendContractModal')
				.modal('show')
				.on('shown.bs.modal', () => {
					const input = $('#sendContractModal').find('input');

					validationService.isModalClosePrevented(input);
				});
		}

		$scope.showSendContractModal = e => {
			$scope.contractData2Send = undefined;

			const addNewModal = $('#addNewModal');
			let DELAY = 500;

			if (addNewModal.hasClass('in')) {
				$('#addNewModal').modal('hide');
			} else {
				DELAY = 0;
			}

			templateRequestsService.getTemplates('contract_preview').subscribe(
				data => {
					$scope.contractData2Send = angular.copy(data);
					$scope.contractData2Send.contracts = data.contractTemplates;
					$scope.contractData2Send.contractEmailTemplates = data.emailTemplates;
					$scope.contractData2Send.mailSignature = data.signature || '';
					$scope.contractData2Send.emailTo = $rootScope.primaryContact.email;
					$scope.contractData2Send.jobId = $scope.job.id;

					if (!$scope.$$phase) {
						$scope.$apply();
					}

					$timeout(() => {
						$('#sendFirstContractModal').modal('show');
					}, DELAY);
				},
				err => messageService.showDefaultErrorMessage(err)
			);
		};

		$scope.editContract = (id, e) => {
			if (id && !$scope.updatedContract) {
				const editContractTemplateCallback = data => {
					$scope.editableContract = angular.copy(data);
				};

				templateRequestsService
					.getTemplates('contract_full', id)
					.subscribe(
						data => editContractTemplateCallback(data),
						error => showGeneralErrorMessage(error)
					);
			} else if ($scope.updatedContract) {
				$scope.editableContract = angular.copy($scope.updatedContract);
			} else if (!$scope.editableContract) {
				$scope.editableContract = {
					text: ''
				};
			}
			utilsService.showNextModal(
				'#sendNewContractModal',
				'#editContractModal',
				e
			);
		};

		$scope.closeEditContract = () => {
			$('#editContractModal')
				.modal('hide')
				.on('hidden.bs.modal', function() {
					$('#sendNewContractModal').modal('show');
					$scope.editableContract = null;
					$(this).off('hidden.bs.modal');
				});
		};

		$scope.saveEditedContract = () => {
			if (!contractService.contractTextValid($scope.editableContract.text)) {
				return;
			}

			$scope.isEditContractModalSpinnningWheelActive = true;
			const contractName = stringModifierService.cutSelectedText(
				$scope.editableContract.name
			);
			messageService.showToaster('s_2', 'contractTemplates', contractName);
			$('#editContractModal')
				.modal('hide')
				.on('hidden.bs.modal', function() {
					$scope.updatedContract = $scope.editableContract;
					$('#sendNewContractModal').modal('show');
					$(this).off('hidden.bs.modal');
					$scope.isEditContractModalSpinnningWheelActive = false;
				});
		};

		$scope.setContractEmailTemplate = id => {
			const contractSetEmailCallback = data => {
				$scope.contractEmailTemplate = angular.copy(data);
				if (data.storedAttachments && data.storedAttachments.length) {
					$scope.attachmentsDataContract = {
						attachments: fileUploadService.convertAttachmentsToShow(
							data.storedAttachments
						)
					};
				} else {
					clearContractAttachments();
				}
			};
			templateRequestsService
				.getTemplates('full_template', id)
				.subscribe(
					data => contractSetEmailCallback(data),
					error => showGeneralErrorMessage(error)
				);
		};

		$scope.sendNewContractEmail = (
			chosenContract,
			updatedContract,
			contractEmailTemplate
		) => {
			const maxSize = 10; // 10Mb

			if (
				$scope.attachmentsDataContract &&
				$scope.attachmentsDataContract.filesSize > maxSize
			) {
				messageService.showToaster('w_0', 'attachments');
				$scope.initSendContractSpinningWheel = false;
				return false;
			}

			let _emailText = '';

			if (validationService.isStringEmpty(contractEmailTemplate.subject)) {
				messageService.showToaster('e_10', 'emailTemplate');
				return;
			}

			if ($scope.sendMessage && $scope.sendMessage.emailText) {
				_emailText = $scope.sendMessage.emailText;
			} else {
				_emailText = $('.in .textarea-quad textarea').val();
			}

			if (!$scope.sendMessage) {
				$scope.sendMessage = {};
			}

			$scope.sendMessage.emailText = $rootScope.addMaiStyling(_emailText);

			if (
				validateNewContractEmail(
					contractEmailTemplate,
					updatedContract,
					chosenContract
				)
			) {
				$scope.sendMessageContract.emailSubject = contractEmailTemplate.subject;

				const mailData = emailService.prepareEmails($scope.sendMessageContract);

				if (!emailService.validateMails(mailData)) {
					return;
				}

				$scope.emailDataToSaveContract = Object.assign(
					{},
					$scope.sendMessageContract,
					mailData
				);
				delete $scope.emailDataToSaveContract.emailCc;

				const obj2save = angular.copy($scope.emailDataToSaveContract);
				const emailCC2save = $scope.showCcField ? obj2save.ccEmails : '';
				const contract2Save = updatedContract
					? updatedContract.text
					: chosenContract.text;

				const data = {
					emailTo: $scope.emailDataToSaveContract.emailTo,
					emailText: contractEmailTemplate.text,
					emailSubject: contractEmailTemplate.subject,
					contractId: chosenContract ? chosenContract.templateId : null,
					jobId: $scope.job.id,
					templateId: contractEmailTemplate.id
				};

				if ($scope.emailDataToSaveContract.secondaryToEmails) {
					data.secondaryToEmails =
						$scope.emailDataToSaveContract.secondaryToEmails;
				}

				if (emailCC2save) {
					data.ccEmails = emailCC2save;
				}

				if (contract2Save) {
					data.contractText = contract2Save;
				}

				$scope.button_disable = true;
				leadViewRequests.sendNewContractEmail(
					data,
					data => {
						if (data) {
							const { errorMessage, errorTitle } = data;
							if (errorMessage) {
								messageService.showErrorFromBackend(errorTitle, errorMessage);
								$scope.button_disable = false;
								return;
							}
						}

						leadViewRequests.getLead();
						$scope.button_disable = false;
						$('#sendNewContractModal').modal('hide');

						$scope.showCcField = false;
						$scope.$evalAsync();
						$('#sendNewQuestionnaireModal').modal('hide');

						for (const prop in $scope.sendMessage) {
							$scope.sendMessage[prop] = '';
						}
						for (const prop in $scope.sendMessageContract) {
							$scope.sendMessageContract[prop] = '';
						}

						if (
							$scope.attachmentsDataContract &&
							$scope.attachmentsDataContract.attachments
						) {
							if ($scope.attachmentsDataContract.attachments.length) {
								$scope.attachmentsDataContract.attachments.length = 0;
							}
						}

						// toastr.success("Contract successfully sent!")
						messageService.showToaster('s_4', 'jobView');
					},
					({ status, data }) => {
						$scope.button_disable = false;
						const path = $location.path();
						const errorMessage = data.errorMessage;

						if (status >= 400 && status < 500 && errorMessage) {
							if (status == 423) {
								const limit = $rootScope.isUserTrial ? 50 : 150;
								return messageService.showToaster(
									'e_4',
									'generalValidation',
									limit
								);
							} else if (errorMessage.includes('Email address inactive')) {
								messageService.showToaster(
									'e_1',
									'generalValidation',
									$scope.sendMessageContract.emailTo
								);
							} else if (path.includes('leads')) {
								messageService.showToaster('e_0', 'contract');
							} else {
								messageService.showToaster('e_2', 'general', errorMessage);
							}
						}
						// else {
						//     messageService.showToaster('e_0', 'general');
						// }
					}
				);
			}
		};

		function validateNewContractEmail(
			emailTemplate,
			updatedContract,
			chosenContract
		) {
			if (!updatedContract && !chosenContract) {
				messageService.showToaster('w_0', 'jobView');
				return false;
			}

			if (!emailTemplate) {
				messageService.showToaster('e_0', 'general');
				return false;
			}

			if (!emailTemplate.subject) {
				messageService.showToaster('e_5', 'workflow');
				return false;
			}

			if (
				!emailTemplate.text ||
				!emailTemplate.text.includes('%contract_link%')
			) {
				messageService.showToaster('e_2', 'emailTemplate');
				return false;
			}

			return true;
		}

		// modal mail
		$scope.setClientMail = (clientMailData, jobMailData) => {
			$scope.clientMailData = clientMailData;
			$scope.mailData2Save = jobMailData;
		};

		$scope.sendNewMailEmail = (
			chosenContract,
			updatedContract,
			contractEmailTemplate
		) => {
			const maxSize = 10; // 10Mb

			if (
				$scope.attachmentsDataContract &&
				$scope.attachmentsDataContract.filesSize > maxSize
			) {
				messageService.showToaster('w_0', 'attachments');
				$scope.initSendContractSpinningWheel = false;
				return false;
			}

			let _emailText = '';

			if ($scope.sendMessage && $scope.sendMessage.emailText) {
				_emailText = $scope.sendMessage.emailText;
			} else {
				_emailText = $('.in .textarea-quad textarea').val();
			}

			if (!$scope.sendMessage) {
				$scope.sendMessage = {};
			}

			$scope.sendMessage.emailText = $rootScope.addMaiStyling(_emailText);

			const obj2save = angular.copy($scope.sendMessageContract);
			const emailCC2save = $scope.showCcField ? obj2save.emailCc : '';

			const data = {
				emailTo: $scope.sendMessage.emailTo,
				emailCc: emailCC2save,
				emailText: contractEmailTemplate.text,
				emailSubject: contractEmailTemplate.subject,
				jobId: $scope.job.id,
				templateId: contractEmailTemplate.id
			};

			$scope.button_disable = true;
			const url = `/api/user/lead/${id}/send/5/`;

			$http({
				method: 'POST',
				url,
				data,
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined
				}
			});
		};

		// Invoice methods
		$scope.showSendInvoice = function(invoiceId) {
			$routeParams.id = invoiceId;

			delete $scope.sendMessage;
			$scope.sendMessage = {};
			$scope.sendMessage.addInvoiceAttachment = true;

			templateRequestsService.getTemplates('all').subscribe(
				data => {
					if (data) {
						$scope.emails = data;
						if ($scope.emails && $scope.emails.length > 1) {
							$scope.choosenEmail =
								$scope.emails.find(
									item => item.emailTemplateType === 'INVOICE_EMAIL_TEMPLATE'
								) || {};
						}

						$scope.sendMessage.emailTo = $rootScope.primaryContact.email;
						$scope.sendMessage.emailCc = '';
						$('#sendInvoiceModal')
							.modal('show', {
								primaryContact: $scope.primaryContact,
								secondaryContact: $scope.secondaryContact
							})
							.on('shown.bs.modal', function() {
								const input = $(this).find('input');
								const select = $(this).find('select');

								validationService.isModalClosePrevented(input);
								validationService.isModalClosePrevented(select);
							});
					}
				},
				err => messageService.showDefaultErrorMessage(err)
			);
		};

		$scope.createNewInvoice = leadId => {
			$scope.createNewInvoiceSpinningWheel = true;
			if ($scope.fundyIntegration || $scope.proSelectIntegration) {
				$('#leadsAddNewInvoiceModal')
					.modal('show')
					.on('shown.bs.modal', () => {
						$scope.createNewInvoiceSpinningWheel = false;
					});
			} else {
				goToNewPayment(`/leads/${leadId}/invoice/new`);
			}
		};

		$scope.redirectToNewInvoice = leadId => {
			$scope.integrationInvoiceLoadXml = true;
			goToNewPayment(`/leads/${leadId}/invoice/new`);
		};

		$scope.openFundyFileUploadModal = event => {
			event.preventDefault();
			document.getElementById('fundyUpload').click();
		};

		$scope.openProSelectFileUploadModal = event => {
			event.preventDefault();
			document.getElementById('proSelectUpload').click();
		};

		$scope.addNewInvoiceFromModal = leadId => {
			if ($scope.fundyIntegration || $scope.proSelectIntegration) {
				$scope.createNewInvoiceSpinningWheel = true;
				const selectModal = '#addNewModal';
				const nextModal = '#leadsAddNewInvoiceModal';
				utilsService.showNextModal(selectModal, nextModal);
				$timeout(() => {
					$scope.createNewInvoiceSpinningWheel = false;
				}, 1000);
			} else {
				goToNewPayment(`/leads/${leadId}/invoice/new`);
			}
		};

		$scope.importInvoiceFromFundy = item => {
			$scope.integrationInvoiceLoadXml = true;
			const jobid = $scope.job.id;
			fileUploadDataService
				.sendFundyXmlFile(item, jobid)
				.finally(() => {
					$scope.integrationInvoiceLoadXml = false;
				})
				.subscribe(result => {
					$scope.integrationInvoiceLoadXml = false;
					const invoiceId = result.invoiceId;
					messageService.showToaster('s_2', 'fundy');
					$('#leadsAddNewInvoiceModal').modal('hide');
					goToLocation(`/invoices/${invoiceId}`);
				});
		};

		$scope.importInvoiceFromProSelect = item => {
			$scope.integrationInvoiceLoadXml = true;
			const jobid = $scope.job.id;
			fileUploadDataService
				.sendProSelectXmlFile(item, jobid)
				.finally(() => {
					$scope.integrationInvoiceLoadXml = false;
				})
				.subscribe(result => {
					$scope.integrationInvoiceLoadXml = false;
					const invoiceId = result.invoiceId;
					messageService.showToaster('s_2', 'proSelect');
					$('#leadsAddNewInvoiceModal').modal('hide');
					goToLocation(`/invoices/${invoiceId}`);
				});
		};

		function calculateInvoices() {
			$scope.paymentsTotal = 0;
			$scope.paymentsBalanceDue = 0;
			$scope.recentInvoice = null;
			$scope.nextInvoice = null;
			$scope.job.payments = $filter('orderBy')(
				$scope.job.invoices,
				'invoiceDue',
				false
			);

			if ($scope.job && $scope.job.payments) {
				angular.forEach($scope.job.payments, (value, key) => {
					$scope.paymentsTotal += value.amount;
					if (value.editable) {
						if ($scope.nextInvoice == null) {
							$scope.nextInvoice = value;
						}
						$scope.paymentsBalanceDue += value.amount;
					} else if ($scope.recentInvoice == null) {
						$scope.recentInvoice = value;
					}
				});
				if ($scope.recentInvoice == null) {
					$scope.recentInvoice = $scope.nextInvoice;
				}
			}
		}

		// Quotes methods
		$scope.showNewQuote = () => {
			const selectModal = '#addNewModal';
			const nextModal = '#addNewQuoteTypeModal';
			utilsService.showNextModal(selectModal, nextModal);
		};

		$scope.createNewQuote = quoteType => {
			goToNewPayment(`/leads/${$scope.leadId}/quote/${quoteType}/new`);
		};

		$scope.showAddNewQuoteModal = () => {
			$('#addNewQuoteTypeModal').modal('show');
		};

		// Questionnaire methods
		$scope.initSendQuestionnaire = () => {
			$('#sendFirstQuestionnaireMessageData_emailCc').val('');

			const addNewModal = $('#addNewModal');
			let DELAY = 500;

			if (addNewModal.hasClass('in')) {
				$('#addNewModal').modal('hide');
			} else {
				DELAY = 0;
			}

			templateRequestsService
				.getTemplates('questionnaire_preview')
				.subscribe(data => {
					successInitSendQuestionnaire(data);
					$timeout(() => {
						$('#sendNewQuestionnaireModal')
							.modal('show')
							.on('shown.bs.modal', () => {
								const input = $('#sendNewQuestionnaireModal').find('input');

								validationService.isModalClosePrevented(input);
							});
					}, DELAY);
				});
		};

		function successInitSendQuestionnaire(data) {
			$scope.initSendQuestionnaireSpinningWheel = true;
			$scope.questionnaireSendSource = data;
			$scope.questionnaires =
				$scope.questionnaireSendSource.questionnaireTemplates;
			$scope.questionnaireEmailTemplates =
				$scope.questionnaireSendSource.emailTemplates;

			const template =
				$scope.questionnaireEmailTemplates.find(
					item => item.emailTemplateType === 'QUESTIONNAIRE_EMAIL_TEMPLATE'
				) || {};

			$scope.choosenQuestionnaireEmail = template;

			if ($scope.questionnaireEmailTemplates) {
				$scope.setQuestionnaireEmailTemplate(template.id);
			}

			delete $scope.sendMessageQuestion;
			$scope.sendMessageQuestion = {};
			$scope.sendMessageQuestion.emailTo = $rootScope.primaryContact.email
				? [$rootScope.primaryContact.email]
				: [];
			if ($scope.secondaryContact) {
				$scope.sendMessageQuestion.emailTo.push($scope.secondaryContact.email);
			}
			$scope.sendMessageQuestion.emailCc = [];
			$scope.initSendQuestionnaireSpinningWheel = false;
		}

		$scope.setEmailData = (newData, object, property) => {
			$scope[object][property] = newData;
		};

		$scope.showSendQuestionnaire = (jobId, questionnaireId, task) => {
			$rootScope.showCcField = false;
			$routeParams.questionnaireId = questionnaireId;
			$routeParams.jobId = jobId;
			$scope.sendMessage = {};
			$scope.sendMessage.emailTo = $rootScope.primaryContact.email
				? [$rootScope.primaryContact.email]
				: [];
			if ($scope.secondaryContact) {
				$scope.sendMessage.emailTo.push($scope.secondaryContact.email);
			}
			$scope.sendMessage.emailCc = [];
			$scope.isDisable = false;
			if (task !== undefined) {
				$scope.task = JSON.parse(JSON.stringify(task));
				$scope.sortedTasksArrQuestionnarie = $scope.sortedTasksArr;
				$scope.isDisable = true;
			}
			templateRequestsService
				.getTemplates('questionnaire_preview')
				.subscribe(data => successShowSendQuestionnaire(data));
		};

		function successShowSendQuestionnaire(data) {
			$scope.questionnaireSendSource = data;
			$scope.questionnaireEmailTemplates = data.emailTemplates;

			const template =
				$scope.questionnaireEmailTemplates.find(
					item => item.emailTemplateType === 'QUESTIONNAIRE_EMAIL_TEMPLATE'
				) || {};

			$scope.choosenQuestionnaireEmail = template;
			$scope.setQuestionnaireEmailTemplate(template.id);

			$('#sendQuestionnaireModal')
				.modal('show')
				.on('shown.bs.modal', () => {
					const input = $('#sendQuestionnaireModal').find('input');

					validationService.isModalClosePrevented(input);
				});
		}

		$scope.setQuestionnaireEmailTemplate = id => {
			const questionnaireSetEmailCallback = data => {
				$scope.questionnaireEmail = angular.copy(data);
				if (data.storedAttachments && data.storedAttachments.length) {
					$scope.attachmentsDataQueston = {
						attachments: fileUploadService.convertAttachmentsToShow(
							data.storedAttachments
						)
					};
				} else {
					clearQuestAttachments();
				}
			};

			templateRequestsService
				.getTemplates('full_template', id)
				.subscribe(
					data => questionnaireSetEmailCallback(data),
					error => showGeneralErrorMessage(error)
				);
		};

		$scope.sendNewQuestionnaireEmail = function(
			chosenQuestionnaire,
			questionnaireEmailTemplate
		) {
			const maxSize = 10; // 10Mb

			if (
				$scope.attachmentsDataQueston &&
				$scope.attachmentsDataQueston.filesSize > maxSize
			) {
				messageService.showToaster('w_0', 'attachments');
				$scope.initSendQuestionnaireSpinningWheel = false;
				$scope.button_disable = false;
				return false;
			}

			if (validationService.isStringEmpty(questionnaireEmailTemplate.subject)) {
				messageService.showToaster('e_10', 'emailTemplate');
				return;
			}

			if (
				$scope.questionnaireEmail &&
				$scope.questionnaireEmail.text &&
				chosenQuestionnaire
			) {
				if (
					questionnaireEmailTemplate &&
					questionnaireEmailTemplate.text &&
					questionnaireEmailTemplate.subject
				) {
					questionnaireEmailTemplate.text = $rootScope.addMaiStyling(
						questionnaireEmailTemplate.text
					);

					$scope.sendMessageQuestion.emailSubject =
						questionnaireEmailTemplate.subject;

					const mailData = emailService.prepareEmails(
						$scope.sendMessageQuestion
					);

					if (!emailService.validateMails(mailData)) {
						return;
					}

					$scope.emailDataToSaveQuestion = Object.assign(
						{},
						$scope.sendMessageQuestion,
						mailData
					);
					delete $scope.emailDataToSaveQuestion.emailCc;

					const obj2save = angular.copy($scope.emailDataToSaveQuestion);
					const emailCC2save = $scope.showCcField ? obj2save.ccEmails : '';

					const data = {
						emailTo: $scope.emailDataToSaveQuestion.emailTo,
						emailText: questionnaireEmailTemplate.text,
						emailSubject: questionnaireEmailTemplate.subject,
						questionnaireTemplateId: chosenQuestionnaire.id || null,
						jobId: $scope.job.id,
						templateId: questionnaireEmailTemplate.id
					};

					if ($scope.emailDataToSaveQuestion.secondaryToEmails) {
						data.secondaryToEmails =
							$scope.emailDataToSaveQuestion.secondaryToEmails;
					}

					if (emailCC2save) {
						data.ccEmails = emailCC2save;
					}

					$scope.button_disable = true;
					leadViewRequests.sendNewQuestionnaireEmail(
						data,
						data => {
							if (data) {
								const { errorMessage, errorTitle } = data;
								if (errorMessage) {
									messageService.showErrorFromBackend(errorTitle, errorMessage);
									$scope.button_disable = false;
									return;
								}
							}

							leadViewRequests.getLead();
							$scope.button_disable = false;
							$scope.showCcField = false;
							$scope.$evalAsync();
							$('#sendNewQuestionnaireModal').modal('hide');

							for (const prop in $scope.sendMessageQuestion) {
								$scope.sendMessageQuestion[prop] = '';
							}
							if (
								$scope.attachmentsDataQueston &&
								$scope.attachmentsDataQueston.attachments
							) {
								if ($scope.attachmentsDataQueston.attachments.length) {
									$scope.attachmentsDataQueston.attachments.length = 0;
								}
							}
							messageService.showToaster('s_9', 'jobView');
						},
						({ status, data }) => {
							$scope.button_disable = false;
							const path = $location.path();
							const errorMessage = data.errorMessage;

							if (status >= 400 && status < 500 && errorMessage) {
								if (status == 423) {
									const limit = $rootScope.isUserTrial ? 50 : 150;
									messageService.showToaster('e_4', 'generalValidation', limit);
								} else if (errorMessage.includes('Email address inactive')) {
									messageService.showToaster(
										'e_1',
										'generalValidation',
										$scope.sendMessageQuestion.emailTo
									);
								} else if (path.includes('leads')) {
									messageService.showToaster('e_0', 'questionnaires');
								} else {
									messageService.showToaster('e_2', 'general', errorMessage);
								}
							}
							// else {
							//     messageService.showToaster('e_0', 'general');
							// }
						}
					);
				} else {
					// toastr.warning("Fill data first");
					messageService.showToaster('w_0', 'jobView');
				}
			} else {
				// toastr.warning("Fill data first");
				messageService.showToaster('w_0', 'jobView');
			}
		};

		// Notes methods
		$scope.showEditNotesModal = () => {
			$scope.editNotes = $scope.job.notes || '';
			$('#updateModal').modal('show');
		};

		$scope.saveNotes = () => {
			$scope.isSaveNotesSpinnningWheelActive = true;
			const notesTmp = $rootScope.addMaiStyling($scope.editNotes);

			const data4Save = {
				id: $scope.job.id,
				notes: notesTmp
			};

			notesDataService
				.saveNotes(data4Save, false)
				.finally(() => {
					$scope.isSaveNotesSpinnningWheelActive = false;
				})
				.subscribe(
					data => {
						const { message, errorMessage } = data;

						if (message) {
							messageService.showToaster('s_3', 'jobView');
							$('#updateModal').modal('hide');
							// $rootScope.updateEditJobModalData = true;
							$scope.job.notes = notesTmp;
							$scope.job2Edit.notes = notesTmp;
						} else {
							toastr.error(errorMessage);
						}
					},
					err => messageService.showDefaultErrorMessage(err)
				);
		};

		// Email methods
		$scope.openSendEmailForReply = function() {
			utilsService.closeAllModalsAndOpenNew('#sendContactEmailModal');
		};

		$scope.showSendEmailModal = function(leadId, task, selectedContact) {
			delete $scope.mailData2Save;
			delete $scope.clientMailData;

			Rx.Observable.zip(
				templateRequestsService.getTemplates('general_preview'),
				templateRequestsService.getTemplates('email_signature')
			)
				.takeUntil($scope.unsubscribe)
				.finally(() => ($scope.showSendEmailModalSpinningWheel = false))
				.subscribe(([emails, mailSignature]) => {
					selectedContact
						? ($scope.mailData2Save = angular.copy(selectedContact))
						: ($scope.mailData2Save = angular.copy($scope.primaryContact));

					$scope.mailData2Save.emails = emails;
					$scope.mailData2Save.mailSignature = mailSignature.signature || '';
					if (!selectedContact && $scope.secondaryContact) {
						$scope.mailData2Save.secondaryEmail = $scope.secondaryContact.email;
					}
					if (task !== undefined) {
						$scope.mailData2Save.emailSubject = task.taskEmail.subject;
						$scope.mailData2Save.emailText = task.taskEmail.text;
						$scope.mailData2Save.task = JSON.parse(JSON.stringify(task));
						$scope.mailData2Save.jobId = $scope.job.id;
						$scope.mailData2Save.sortedTasksArr = $scope.sortedTasksArr;
						$scope.mailData2Save.isDisable = true;
					}

					$rootScope.clientToken = false;

					if (!$scope.$$phase) {
						$scope.$apply();
					}

					$routeParams.leadId = $scope.leadId;
					$scope.leadId = leadId;
					$('#sendContactEmailModal').modal('show');
				});
		};

		$scope.showSendModal = function(task) {
			if (task.completed === true) {
				switch (task.action) {
					case 'SEND_EMAIL':
						$scope.showSendEmailModal($scope.leadId, task);
						break;
					case 'SEND_QUESTIONNAIRE':
						$scope.tickTask = true;
						$scope.tickTaskType = 'QUESTIONNAIRE';
						openEditAutomationTask(task);
						break;
					case 'SEND_CONTRACT':
						$scope.tickTask = true;
						$scope.tickTaskType = 'CONTRACT';
						openEditAutomationTask(task);
						break;
				}
			}
		};

		function openEditAutomationTask(task) {
			workflowService.setTaskInfo(task, $scope.job.workflow.tasks, true);
			$('#addAutomationModal').modal('show');
		}

		$scope.disableDragDrop = function() {
			return true;
		};

		$scope.retrySendMail = function() {
			leadViewRequests.getLead();
			emailService.callLastEmailFn();
		};

		$scope.addSubjectVariable = function($event, id, type) {
			const el = document.getElementById(id);
			const subject = emailService.addSubjectVariable(el, $event);
			if ($scope.sendMessage) {
				$scope.sendMessage.emailSubject = subject;
			}

			if (type === 'QUESTIONNAIRE') {
				$scope.questionnaireEmail.subject = subject;
			}

			if (type === 'CONTRACT') {
				$scope.contractEmailTemplate.subject = subject;
			}
		};

		$scope.toggleViewCc = function(state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = '';
				$scope.$evalAsync();
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;

			if (state === false) {
				clearQuestAttachments();
				clearContractAttachments();
			}
		};

		// attachments

		function setAttachments(attachments) {
			$scope.files = fileUploadService.setAttachmentsFromServer(attachments);
			fileUploadDataService.setAttachmentsFromServer(attachments);
			$scope.$broadcast('addedFileEvent');
		}

		function clearContractAttachments() {
			$scope.attachmentsDataContract = {
				attachments: [],
				filesSize: 0
			};
		}

		function clearQuestAttachments() {
			$scope.attachmentsDataQueston = {
				attachments: [],
				filesSize: 0
			};
		}

		// Workflow methods
		$scope.getWorkflow = () => {
			if (
				!$scope.job ||
				$scope.job.id === null ||
				$scope.job.id === undefined
			) {
				return false;
			}
			workflowService.getJobWorkflow($scope.job.id, successGetWorkflow);
		};

		function successGetWorkflow(workflow) {
			$scope.job.workflow = workflow;
			prepareTasks();
		}

		const fillWorkflowTasks = (taskList = []) => {
			[
				$scope.lead,
				$scope.production,
				$scope.postProduction
			] = workflowService.fillWorkflowTasks(taskList);
		};

		const handleTask = (task, taskTypes) => {
			if (task.dateItem) {
				task.dateItem = task.dateItem.toLowerCase();
			}

			if (task.due && !task.hasDue) {
				// for old workflows
				task.hasDue = true;
			}

			if (!task.action && task.taskEmail) {
				// for old workflows
				task.action = 'SEND_EMAIL';
			}

			if (task.calendarEventType === 'MAIN_SHOOT') {
				const {
					startDate,
					finishDate,
					startTime,
					finishTime,
					location
				} = $scope.job;
				task.location = location;
				task.startDate = startDate;
				task.endDate = finishDate;
				task.startTime = startTime;
				task.endTime = finishTime;
			} else if (task.calendarEvent) {
				const {
					startDate,
					endDate,
					startTime,
					endTime,
					location,
					clientId
				} = task.calendarEvent;
				task.location = location;
				task.startDate = startDate;
				task.endDate = endDate;
				task.startTime = startTime;
				task.endTime = endTime;
				task.sendEmails = clientId ? task.calendarEvent.sendEmails : false;

				if (
					task.startDate &&
					(task.startTime === null || task.finishTime === null)
				) {
					task.allday = true;
				}
			}

			task.overdueDays = workflowService.calcTaskOverdue(task.overdueDays);
			task.taskViewDue = workflowService.getTaskViewDue(task, taskTypes);
			task.taskDueDefault =
				task.defaultTask && task.dueDate ? task.dueDate : null;
		};

		const getSortedTasks = () => [
			$scope.lead,
			$scope.production,
			$scope.postProduction
		];

		function prepareTasks() {
			if (!$scope.job.workflow) {
				return false;
			}

			let taskList = angular.copy($scope.job.workflow.tasks);
			taskList = $filter('orderBy')($scope.job.workflow.tasks, 'number', false);
			fillWorkflowTasks(taskList);

			$scope.sortedTasksArr = getSortedTasks();
			$scope.job.workflow.tasks.forEach(item =>
				handleTask(item, $scope.sortedTasksArr)
			);
			if ($scope.job.showNewTaskId) {
				$timeout(() => {
					const newTask = taskList.find(
						task => task.id === $scope.job.showNewTaskId
					);
					const taskToAnimate = `.task-${newTask.number}`;
					$rootScope.$broadcast('animateTask', taskToAnimate);
					// next line removes parameters from route
					$location.search({}).replace();
				}, 0);
			}
			$scope.correctSortedTasksArray = angular.copy($scope.sortedTasksArr);
		}

		$scope.updateViewAndRenewWorkflow = tasks => {
			$scope.updateLeadView();
			$scope.renewWorkflow(tasks);
		};

		$scope.renewWorkflow = tasks => {
			let taskList = angular.copy(tasks);
			taskList = $filter('orderBy')(tasks, 'number', false);
			fillWorkflowTasks(taskList);
			$scope.sortedTasksArr = getSortedTasks();
			taskList.forEach(item => handleTask(item, $scope.sortedTasksArr));
			$scope.correctSortedTasksArray = angular.copy($scope.sortedTasksArr);
		};

		$scope.showWarningModal = function(task) {
			if (task) {
				emailService.emitClientToCheckSubscription($scope.primaryContact);
				emailService.checkIfEmailAllowedWeb(
					$scope.primaryContact,
					$scope.changeTaskState,
					this,
					[task]
				);
				$scope.retryTask = task;
			}
		};

		$scope.cancelAutomation = function() {
			if ($scope.retryTask) {
				$scope.retryTask.completed = false;
			}
		};

		$scope.changeTaskState = task => {
			$rootScope.dnd.canMove = false;

			newJobsDataService
				.changeTaskState($scope.job.id, task)
				.finally(() => {
					$rootScope.dnd.canMove = true;
					leadViewRequests.getLead();
				})
				.subscribe(
					data => {
						toastr.clear();
						messageService.showToaster('i_0', 'jobView');
						task = Object.assign(task, data);
						handleTask(task, $scope.sortedTasksArr);
					},
					result => {
						toastr.clear();
						messageService.showDefaultErrorMessage(result);
					}
				);
		};

		$scope.changeToLeadOrJob = task => {
			$('#modalChangeLead').modal('show');
			$scope.newTaskCreate = Object.assign(task);
		};

		// Client methods
		function setContacts() {
			const { primaryContact, secondaryContact } = $scope.job;
			$scope.primaryContact = primaryContact;

			if (secondaryContact) {
				$scope.secondaryContact = secondaryContact;
			}
		}

		$scope.chooseContract = () => {
			$scope.updatedContract = null;
		};

		$scope.editClient = client => {
			$scope.clientForEdit = angular.copy(client);
			$scope.companyNameChecked =
				!!$scope.clientForEdit.companyName ||
				!!$scope.clientForEdit.businessNumber;
			$('#editClientModal')
				.modal('show')
				.on('shown.bs.modal', function() {
					const input = $(this).find('input');

					validationService.isModalClosePrevented(input);
				});
		};

		const successSaveClient = data => {
			if (data.errorMessage) {
				toastr.error(data.errorMessage, 'Error');
				$scope.isCreateClientModalSpinnningWheelActive = false;
			} else {
				toastr.success(data.message, 'Success');
				$('#editClientModal').modal('hide');
				delete $scope.clientForEdit;
				leadViewRequests.getLead();
				$scope.isCreateClientModalSpinnningWheelActive = false;
			}
		};

		const errorSaveClient = ({ status, data }) => {
			const errorMessage = data.errorMessage;
			let errorCode, errorPlace, value;

			if (status >= 400 && status < 500 && errorMessage) {
				if (
					errorMessage ===
					'Job contact cannot be changed because invoice has Xero payment'
				) {
					errorCode = 'e_10';
					errorPlace = 'xero';
				} else if (
					errorMessage === 'Sorry, this customer has been deleted on QuickBooks'
				) {
					errorCode = 'e_23';
					errorPlace = 'qb';
				} else if (errorMessage.includes('already registered')) {
					errorCode = 'e_8';
					errorPlace = 'clients';
					value = $scope.clientForEdit.email;
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
				}
			}

			messageService.showToaster(errorCode, errorPlace, value);
		};

		$scope.saveClient = () => {
			$scope.isCreateClientModalSpinnningWheelActive = true;
			if (!$scope.clientForEdit.id) {
				console.error('No client id');
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return;
			}

			if (!validationService.isEmailValid($scope.clientForEdit.email)) {
				console.log('invalid lead');
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return messageService.showToaster('e_3', 'companyUsers');
			}

			if (validationService.isStringEmpty($scope.clientForEdit.firstName)) {
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return messageService.showToaster('e_4', 'clients');
			}

			if (!$scope.companyNameChecked) {
				delete $scope.clientForEdit.companyName;
				delete $scope.clientForEdit.businessNumber;
			}

			if ($scope.clientForEdit.notes) {
				$scope.clientForEdit.notes = $rootScope.addMaiStyling(
					$scope.clientForEdit.notes
				);
			}

			clientsDataService
				.updateClient($scope.clientForEdit)
				.finally(() => ($scope.isCreateClientModalSpinnningWheelActive = false))
				.subscribe(
					data => successSaveClient(data),
					err => errorSaveClient(err)
				);
		};

		// Go-to methods
		function goToLocation(url) {
			$location.path(url);
		}

		function goToNewPayment(url) {
			const addNewModal = $('#addNewModal');
			let delay = 0;

			if (addNewModal.hasClass('in')) {
				addNewModal.modal('hide');
				delay = 500;
			}

			$timeout(() => goToLocation(url), delay);
		}

		$scope.goToQuotePage = (leadId, quoteId) =>
			goToLocation(`/leads/${leadId}/quote/${quoteId}`);

		$scope.goToInvoicePage = (job, invoice) => {
			const { hasInvoices } = job;
			const { invoiceId } = invoice;

			if (hasInvoices) {
				goToLocation(`/invoices/${invoiceId}`);
			}
		};

		$scope.goToContractsPage = (jobId, contractId) =>
			goToLocation(`/jobs/view/${jobId}/contracts/${contractId}`);

		$scope.goToQuestionnairesPage = (jobId, questionnaireId) =>
			goToLocation(`/jobs/view/${jobId}/questionnaires/${questionnaireId}`);

		// Toggle modals
		$scope.showAddNewModal = () => {
			$('#addNewModal').modal('show');
		};

		$scope.showDeleteModal = () => {
			$scope.leadForDelete = $scope.leadId;
			$('#deleteModal').modal('show');
		};

		$scope.showEditJobModal = job => {
			$scope.button_disable = true;
			$scope.isCreateLeadSpinningWheelActive = true;

			if ($scope.job2Edit.startTime) {
				$scope.job2Edit.startTime = timeConverter.convert24to12(
					$scope.job2Edit.startTime
				);
				$scope.job2Edit.finishTime = timeConverter.convert24to12(
					$scope.job2Edit.finishTime
				);
			}

			const checkDefault =
				$scope.job2Edit.workflowNames[$scope.job2Edit.workflowNames.length - 1];
			if (
				checkDefault &&
				checkDefault.name !== 'Default' &&
				checkDefault.id !== ''
			) {
				$scope.job2Edit.workflowNames[
					$scope.job2Edit.workflowNames.length
				] = defaultWorkflow;
			}
			$scope.$broadcast('showModal', { lead: $scope.job2Edit, jobId: job.id });

			$('#newLead').modal('show');

			$scope.isCreateLeadSpinningWheelActive = false;
			$scope.button_disable = false;
		};

		$scope.showAddNewTaskModal = () => {
			$scope.showAddNewTaskModalSpinningWheel = true;
			const addNewModal = $('#addNewModal');
			let DELAY = 500;

			if (addNewModal.hasClass('in')) {
				$('#addNewModal').modal('hide');
			} else {
				DELAY = 0;
			}

			$timeout(() => {
				$('#addWorkflowTaskModal').modal('show');
				$scope.showAddNewTaskModalSpinningWheel = false;
			}, DELAY);
		};

		$scope.showQuoteModal = (jobId, quoteId, type) => {
			$routeParams.jobId = jobId;
			$routeParams.quoteId = quoteId;

			$scope.sendMessage = {};
			$scope.sendMessage.emailTo = $rootScope.primaryContact.email;
			$scope.sendMessage.emailCc = '';

			templateRequestsService.getTemplates('all').subscribe(data => {
				if (data) {
					$scope.emails = data;
					if (data.length > 0) {
						$scope.choosenEmail =
							$scope.emails.find(
								item => item.emailTemplateType === 'QUOTE_EMAIL_TEMPLATE'
							) || {};
					}
					$('#sendQuoteModal').modal('show', {
						primaryContact: $scope.primaryContact,
						secondaryContact: $scope.secondaryContact,
						customToken: type === 'FIXED' ? 'INVOICE_MENU' : 'JOB_MENU'
					});
				}
			});
		};

		// Job methods
		$scope.deleteLead = () => {
			$scope.deleteDisable = true;

			leadDataService
				.deleteLead($scope.leadForDelete)
				.finally(() => {
					$scope.deleteDisable = false;
				})
				.subscribe(
					() => {
						messageService.showToaster('s_2', 'lead');
						$location.path('/leads').replace();
					},
					err => errorDeleteJob(err)
				);
		};

		function errorDeleteJob({ status, data }) {
			const errorMessage = data.errorMessage;
			let errorCode, errorPlace, value;

			if (status >= 400 && status < 500 && errorMessage) {
				if (
					errorMessage.includes(
						'This payment cannot be marked as unpaid because it was overpaid in Xero.'
					)
				) {
					errorCode = 'e_12';
					errorPlace = 'xero';
					value = 'job';
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
				}
			}
			messageService.showToaster(errorCode, errorPlace, value);
		}

		function prepareJob(job) {
			$scope.job2Edit = angular.copy(job);
			$scope.job2Edit.id = $scope.leadId;
			$scope.clients = [];

			const {
				workflow,
				startDate,
				finishDate,
				primaryContact,
				secondaryContact
			} = $scope.job2Edit;

			$scope.job2Edit.oldWorkflow = workflow;

			if (!$scope.job2Edit.startDate) {
				$scope.job2Edit.hasNoDate = true;
			} else {
				$scope.job2Edit.hasNoDate = false;
				$scope.job2Edit.startDate = timeService.createDateAsUTC(startDate);
				//
				$scope.job2Edit.finishDate = timeService.createDateAsUTC(finishDate);
			}
			if (primaryContact) {
				const primaryClientSearchText = clientService.fillClientSearchText(
					primaryContact
				);
				$scope.clients[0] = primaryClientSearchText;
				$scope.job2Edit.primaryContact = $scope.clients[0];
			}

			if (secondaryContact) {
				const secondaryClientSearchText = clientService.fillClientSearchText(
					secondaryContact
				);
				$scope.clients[1] = secondaryClientSearchText;
				$scope.job2Edit.secondaryContact = $scope.clients[1];
			}

			if (
				$scope.job2Edit.startDate &&
				($scope.job2Edit.startTime === null ||
					$scope.job2Edit.finishTime === null)
			) {
				$scope.job2Edit.allday = true;
			}

			getJobTypes();
			getWorkflowAndLanguageNames();
			$scope.$evalAsync();
		}

		function getJobTypes() {
			return jobTypesDataService
				.getJobTypes()
				.finally(() => ($scope.button_disable = false))
				.subscribe(data => successGetJobTypes(data));
		}

		function getWorkflowAndLanguageNames() {
			return workflowDataService
				.getWorkflowAndLanguageNames()
				.finally(() => ($scope.button_disable = false))
				.subscribe(data => successGetWorkflowAndLanguageNames(data));
		}

		function successGetJobTypes(data) {
			$scope.job2Edit.jobTypes = angular.copy(data);
		}

		function successGetWorkflowAndLanguageNames(data) {
			if (!data) {
				return false;
			}
			$scope.job2Edit.workflowNames = angular.copy(data.workflows);
			$scope.job2Edit.languageNames = angular.copy(data.languages);
		}

		// helper functions
		function showGeneralErrorMessage(error) {
			messageService.showToaster('e_0', 'general');
		}

		$scope.setMinWidth = (text = '') => {
			const textLength = text.length;

			if (textLength < 6) {
				return 40;
			} else if (textLength < 10) {
				return 60;
			} else if (textLength < 20) {
				return 100;
			}
			return 190;
		};

		$scope.refreshFileList = () => {
			fileUploadDataService.setFiles($scope.files, true);
		};

		$rootScope.updateLeadView = function() {
			leadViewRequests.getLead();
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/lead/leadViewController.js